import React from "react";
import { Result, Button } from "antd";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                        background: "#f8fafc",
                    }}
                >
                    <Result
                        status="error"
                        title="Something went wrong"
                        subTitle="We apologize for the inconvenience. Please try reloading the page."
                        extra={[
                            <Button type="primary" key="reload" onClick={this.handleReload}>
                                Reload Page
                            </Button>,
                        ]}
                    />
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
